module.exports = __webpack_public_path__ + "cc5409c38387d6a3a87f29dc4390471c.svg";